import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.az{min-height:100vh;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.m{padding:2rem;}.ssr-plugin'
import '.d{gap:2rem;}.ssr-plugin'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'
import { Head } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'

export const MaintenancePage = ({ message }: { message?: string }) => {
  const translations = useTranslations().app

  return (
    <div className="a b c g az ae m d"
    >
      <Head>
        <title>CrowdBuilding</title>
      </Head>
      <Image
        src={fullLogo}
        alt="CrowdBuilding"
        resizeHeight={48}
        style={{ height: '3rem' }}
      />
      <Text.Large
        style={{
          textAlign: 'center',
          maxWidth: '36rem',
        }}
      >
        {message || translations.landingPage.maintenanceMessage}
      </Text.Large>
    </div>
  )
}
